/* DEMO mobile header: builds the rotating orange bar (phones only). Own live countdown to 4pm UK weekdays. */
(function () {
  function build() {
    var bar = document.querySelector('.header-review-bar');
    if (!bar || bar.querySelector('.dc-mbar')) return;
    var w = document.createElement('div');
    w.className = 'dc-mbar';
    w.innerHTML =
      '<a class="dc-ms" href="/pages/our-delivery"><i class="fa fa-truck" aria-hidden="true"></i> Free delivery <small>on orders over £70</small></a>' +
      '<a class="dc-ms" href="/pages/our-delivery"><i class="fa fa-clock-o" aria-hidden="true"></i> Next dispatch: <span class="dc-mclock">--h --m --s</span></a>' +
      '<a class="dc-ms" href="/pages/discount-coffee-reviews">Excellent <span class="dc-mstars">★★★★★</span> <span class="dc-mfw">feefo</span></a>';
    bar.appendChild(w);
    var clock = w.querySelector('.dc-mclock');
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var f = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', hour12: false, weekday: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit' });
      var p = {}; f.formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      var dow = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 0 }[p.weekday];
      var secs = (parseInt(p.hour, 10) % 24) * 3600 + parseInt(p.minute, 10) * 60 + parseInt(p.second, 10);
      var target = 16 * 3600, days = 0, d = dow;
      if (d >= 1 && d <= 5 && secs < target) { days = 0; } else { days = 1; d = (d + 1) % 7; while (d === 0 || d === 6) { d = (d + 1) % 7; days++; } }
      var left = days * 86400 + target - secs;
      var h = Math.floor(left / 3600), m = Math.floor((left % 3600) / 60), s = left % 60;
      clock.textContent = pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
    }
    tick(); setInterval(tick, 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build); else build();
})();

/* v4 (29 Oct): the header search icon goes straight to Rapid Search. Rapid Search opens when the theme's search box is focused, and it takes over the whole screen (it hides the header while open), so the theme's old search panel is never opened. Basket count bubble. Phones only. */
(function () {
  var mq = window.matchMedia ? window.matchMedia('(max-width: 767px)') : { matches: false };

  function rsOpen() {
    var e = document.getElementById('rapid-search-results');
    if (!e) return false;
    var cs = getComputedStyle(e);
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    var r = e.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  // Capture phase, so this runs before the theme's own handler (which would slide the old panel in); we stop that handler and focus the search box ourselves, in the same tap
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('.search-open') : null;
    if (!t || !mq.matches) return;
    var input = document.querySelector('#header-search input[name="q"]');
    if (!input) return; // nothing to launch: let the theme's normal behaviour run
    e.preventDefault();
    e.stopImmediatePropagation();
    input.focus();
    setTimeout(function () {
      if (!rsOpen()) { input.click(); input.focus(); }
    }, 300);
  }, true);

  // Basket: show the item count in a bubble on the basket icon (the old (n) text is hidden on phones)
  function syncCount() {
    var b = document.getElementById('main-nav-basket');
    if (!b) return;
    var a = b.querySelector('a');
    var src = b.querySelector('.item-count');
    if (!a || !src) return;
    var n = parseInt((src.textContent || '').replace(/[^0-9]/g, ''), 10) || 0;
    var bub = a.querySelector('.dc-count');
    if (!bub) { bub = document.createElement('span'); bub.className = 'dc-count'; a.appendChild(bub); }
    bub.textContent = n > 99 ? '99+' : String(n);
    b.classList.toggle('dc-empty', n === 0);
    a.setAttribute('aria-label', 'Basket, ' + n + (n === 1 ? ' item' : ' items'));
  }

  function init() {
    syncCount();
    var src = document.querySelector('#main-nav-basket .item-count');
    if (src && window.MutationObserver) new MutationObserver(syncCount).observe(src, { childList: true, characterData: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* v5 (29 Oct): mobile menu. Marks SALE so it can be orange. */
(function () {
  function run() {
    var menu = document.getElementById('main-nav-pulldown-menus');
    if (!menu) return;
    Array.prototype.forEach.call(menu.querySelectorAll('.main-nav-pulldown-menus-row > li'), function (li) {
      var a = li.querySelector('a.mobile-nav-top-header');
      if (a && /^\s*sale\s*$/i.test(a.textContent)) li.classList.add('dc-sale');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* v7 to v17 (29 Oct): Shop / Help / currency tabs at the top of the phone menu (the Help tab is a compact version of the Customer Service page; the currency tab is a DEMO: it changes the symbol only, prices stay in pounds), category sections that start closed, a title at the top of each inner menu, 'View all' wording, and picture tiles for the menus that have pictures (Cups, Brands). */
(function () {
  var mq = window.matchMedia ? window.matchMedia('(max-width: 767px)') : { matches: false };
  var menu = null;
  var CUR = [
    { s: '£', c: 'GBP', n: 'Pound sterling' },
    { s: '€', c: 'EUR', n: 'Euro' }
  ];
  var curIdx = 0;

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function titleCase(s) { return String(s).toLowerCase().replace(/(^|[\s(\/-])([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); }); }

  // Help tab links: [icon, title, page, shows the 'new' dot]
  var TILES = [
    ['fa-truck', 'Our Delivery', '/pages/our-delivery', true],
    ['fa-undo', 'Damages & Returns', '/pages/damages-returns', false],
    ['fa-question-circle-o', 'FAQs', '/pages/frequently-asked-questions', true],
    ['fa-tag', 'Subscribe for 5% Off', '/pages/subscribe-for-exclusive-offers', false],
    ['fa-shield', 'Your Privacy', '/pages/your-privacy', false],
    ['fa-info-circle', 'About Us', '/pages/about-us', false],
    ['fa-star-o', 'Feefo Reviews', '/pages/discount-coffee-reviews', false],
    ['fa-leaf', 'Social Responsibility', '/pages/our-social-responsibility', true],
    ['fa-globe', 'Carbon Checkout', '/pages/carbon-contribution', false],
    ['fa-life-ring', 'All help topics', '/pages/customer-service', false]
  ];

  function helpHtml() {
    return '<a class="dc-help-call" href="tel:+443304411122"><i class="fa fa-phone" aria-hidden="true"></i><span>Call 0330 44 111 22</span></a>' +
      '<p class="dc-help-status"><i aria-hidden="true"></i><span data-dc-status>Phones Monday to Friday, 9am to 5pm. Live chat open 24 hours.</span></p>' +
      '<div class="dc-help-top"><button type="button" class="dc-hbtn dc-hbtn-out" data-dc-chat>Live chat</button><a class="dc-hbtn dc-hbtn-out" href="/pages/contact-us">Contact us</a></div>' +
      '<div class="dc-hgrid">' + TILES.map(function (t) {
        return '<a class="dc-ht" href="' + t[2] + '"><span class="dc-hti"><i class="fa ' + t[0] + '" aria-hidden="true"></i></span><span>' + esc(t[1]) + '</span>' + (t[3] ? '<span class="dc-ndot" title="New"></span>' : '') + '</a>';
      }).join('') + '</div>';
  }

  function curHtml() {
    return '<h4 class="dc-hh">Currency</h4>' + CUR.map(function (o, i) {
      return '<button type="button" class="dc-co" data-i="' + i + '" aria-selected="' + (i === curIdx ? 'true' : 'false') + '"><span class="dc-cosym">' + o.s + '</span><span class="dc-cotx">' + o.c + '<small>' + o.n + '</small></span></button>';
    }).join('') + '<p class="dc-curnote">Demo only: prices stay in pounds until multi-currency is switched on.</p>';
  }

  // Phones open Monday to Friday 9am to 5pm, London time (same rule as the Customer Service page)
  function paintStatus(el) {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' }).formatToParts(new Date());
      var o = {};
      parts.forEach(function (p) { o[p.type] = p.value; });
      var day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(o.weekday);
      var mins = parseInt(o.hour, 10) * 60 + parseInt(o.minute, 10);
      if (day < 0 || isNaN(mins)) return;
      var weekday = day >= 1 && day <= 5;
      if (weekday && mins >= 540 && mins < 1020) {
        el.textContent = 'Phones open until 5pm. Live chat open 24 hours.';
      } else {
        var next = 'open Monday at 9am';
        if (weekday && mins < 540) next = 'open today at 9am';
        else if (day >= 1 && day <= 4) next = 'open tomorrow at 9am';
        el.textContent = 'Phones closed, ' + next + '. Live chat open 24 hours.';
      }
    } catch (e) { /* keep the static text */ }
  }

  function openChat() {
    var tries = [
      function () {
        var b = document.getElementById('chatbase-bubble-button');
        if (!b) return false;
        var label = (b.getAttribute('aria-label') || '').toLowerCase();
        if (label.indexOf('close') !== 0) b.click();
        return true;
      },
      function () { if (window.zE) { window.zE('messenger', 'open'); return true; } },
      function () { if (window.Tawk_API && window.Tawk_API.maximize) { window.Tawk_API.maximize(); return true; } },
      function () { if (window.$crisp) { window.$crisp.push(['do', 'chat:open']); return true; } },
      function () { if (window.Intercom) { window.Intercom('show'); return true; } },
      function () { if (window.tidioChatApi) { window.tidioChatApi.open(); return true; } },
      function () { if (window.GorgiasChat) { window.GorgiasChat.open(); return true; } }
    ];
    for (var i = 0; i < tries.length; i++) {
      try { if (tries[i]()) return true; } catch (e) { /* try the next one */ }
    }
    return false;
  }
  // shared with the footer
  window.dcOpenChat = openChat;
  window.dcPaintStatus = paintStatus;

  function setMode(mode) {
    if (!menu) return;
    menu.classList.toggle('dc-mode-help', mode === 'help');
    menu.classList.toggle('dc-mode-cur', mode === 'cur');
    Array.prototype.forEach.call(menu.querySelectorAll('.dc-tab'), function (t) {
      t.setAttribute('aria-selected', t.getAttribute('data-mode') === mode ? 'true' : 'false');
    });
    menu.scrollTop = 0;
    var inner = document.getElementById('main-nav-pulldown-menus-inner');
    if (inner) inner.scrollTop = 0;
  }

  function paintCur() {
    if (!menu) return;
    var sym = menu.querySelector('.dc-cursym');
    if (sym) sym.textContent = CUR[curIdx].s;
    Array.prototype.forEach.call(menu.querySelectorAll('.dc-co'), function (o, i) {
      o.setAttribute('aria-selected', i === curIdx ? 'true' : 'false');
    });
  }

  function buildTabs() {
    menu = document.getElementById('main-nav-pulldown-menus');
    if (!menu || menu.querySelector('.dc-tabs')) return;
    var ul = menu.querySelector('.main-nav-pulldown-menus-row');
    if (!ul || !ul.parentNode) return;

    var tabs = document.createElement('div');
    tabs.className = 'dc-tabs';
    tabs.setAttribute('role', 'tablist');
    tabs.innerHTML = '<button type="button" class="dc-tab" role="tab" data-mode="shop" aria-selected="true"><i class="fa fa-shopping-bag" aria-hidden="true"></i>Shop</button>' +
      '<button type="button" class="dc-tab" role="tab" data-mode="help" aria-selected="false"><i class="fa fa-question-circle" aria-hidden="true"></i>Help</button>' +
      '<button type="button" class="dc-tab dc-tab-cur" role="tab" data-mode="cur" aria-selected="false" aria-label="Currency"><span class="dc-cursym">' + CUR[0].s + '</span></button>';
    var help = document.createElement('div');
    help.className = 'dc-help';
    help.innerHTML = helpHtml();
    var cur = document.createElement('div');
    cur.className = 'dc-curpanel';
    cur.innerHTML = curHtml();

    ul.parentNode.insertBefore(tabs, ul);
    ul.parentNode.insertBefore(help, ul);
    ul.parentNode.insertBefore(cur, ul);

    var st = help.querySelector('[data-dc-status]');
    if (st) paintStatus(st);

    tabs.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('.dc-tab') : null;
      if (t) setMode(t.getAttribute('data-mode'));
    });

    cur.addEventListener('click', function (e) {
      var o = e.target.closest ? e.target.closest('.dc-co') : null;
      if (!o) return;
      curIdx = parseInt(o.getAttribute('data-i'), 10) || 0;
      paintCur();
    });

    var chat = help.querySelector('[data-dc-chat]');
    if (chat) chat.addEventListener('click', function () {
      var closeBtn = document.getElementById('mobile-nav-button-close');
      if (closeBtn) closeBtn.click();
      setTimeout(function () { if (!openChat()) window.location.href = '/pages/contact-us'; }, 300);
    });
  }

  // Category sections: every heading that has items becomes a tappable row, closed until opened; a 'View all' link keeps the heading's own page reachable
  function buildAccordion() {
    Array.prototype.forEach.call(document.querySelectorAll('#main-nav-pulldown-menus .mobile-ul-list .pulldown-menu-nav-level-2'), function (b) {
      var dl = b.querySelector('dl');
      if (!dl || b.classList.contains('dc-acc')) return;
      var dds = dl.querySelectorAll('dd');
      var a = dl.querySelector('dt a');
      if (!dds.length || !a) return;
      b.classList.add('dc-acc');
      a.setAttribute('role', 'button');
      a.setAttribute('aria-expanded', 'false');
      var dd = document.createElement('dd');
      dd.className = 'dc-viewall';
      var link = document.createElement('a');
      link.href = a.getAttribute('href') || '#';
      link.textContent = 'View all ' + titleCase(a.textContent.replace(/\s+/g, ' ').trim());
      dd.appendChild(link);
      dl.insertBefore(dd, dds[0]);
    });
  }

  // A big title at the top of each inner menu, e.g. 'Coffee', taken from the row that was tapped
  function buildSubheads() {
    Array.prototype.forEach.call(document.querySelectorAll('#main-nav-pulldown-menus .main-nav-pulldown-menus-row > li'), function (li) {
      var sub = li.querySelector('.pulldown-menu-inner-subnav-row');
      if (!sub || sub.querySelector('.dc-subhead')) return;
      var a = li.querySelector('a.mobile-nav-top-header');
      if (!a) return;
      var t = a.textContent.replace(/\s+/g, ' ').trim();
      if (!t) return;
      var h = document.createElement('div');
      h.className = 'dc-subhead';
      h.textContent = titleCase(t);
      var back = sub.querySelector('.mobile-submenu-back');
      if (back && back.parentNode === sub) sub.insertBefore(h, back.nextSibling); else sub.insertBefore(h, sub.firstChild);
    });
  }

  // The theme's 'View COFFEE' link reads 'View all Coffee' instead
  function fixViewLinks() {
    Array.prototype.forEach.call(document.querySelectorAll('#main-nav-pulldown-menus .mobile-top-level-header a'), function (a) {
      var t = a.textContent.replace(/\s+/g, ' ').trim();
      var m = /^view\s+(?!all\b)(.+)$/i.exec(t);
      if (m && a.children.length === 0) a.textContent = 'View all ' + titleCase(m[1]);
    });
  }

  // Picture tiles: any plain menu whose items carry pictures (Cups, Brands) becomes a grid. The theme only supplies 50px thumbnails, so on phones each picture is swapped for the 300px version of the same image (loaded only when the menu is opened). An 'All ...' item (e.g. All Brands) loses its picture and becomes a slim full-width row.
  function buildTiles() {
    Array.prototype.forEach.call(document.querySelectorAll('#main-nav-pulldown-menus .pulldown-menu-inner-subnav-row > .pulldown-menu-nav-level-2'), function (b) {
      if (b.classList.contains('dc-tiles')) return;
      if (!b.querySelector('dd a img')) return;
      b.classList.add('dc-tiles');
      Array.prototype.forEach.call(b.querySelectorAll('dd'), function (dd) {
        var a = dd.querySelector('a');
        if (!a) return;
        var label = a.textContent.replace(/\s+/g, ' ').trim();
        var img = a.querySelector('img');
        if (/^(view\s+)?all\b/i.test(label)) {
          dd.classList.add('dc-wide');
          if (img) img.parentNode.removeChild(img);
          return;
        }
        if (!img || !mq.matches) return;
        var src = img.getAttribute('src') || '';
        var big = src.replace(/_50x(?:50)?(\.[a-z0-9]+)/i, '_300x$1');
        if (big !== src) {
          img.loading = 'lazy';
          img.setAttribute('src', big);
        }
      });
    });
  }

  document.addEventListener('click', function (e) {
    if (!mq.matches) return;
    var a = e.target && e.target.closest ? e.target.closest('.mobile-ul-list .dc-acc dt a') : null;
    if (!a) return;
    e.preventDefault();
    e.stopPropagation();
    var b = a.closest('.dc-acc');
    var open = b.classList.toggle('dc-open');
    a.setAttribute('aria-expanded', open ? 'true' : 'false');
  }, true);

  function init() { buildTabs(); buildAccordion(); buildSubheads(); fixViewLinks(); buildTiles(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* v27 (29 Oct): the footer. The copyright year is set to the current year on every page load. On phones the footer is rebuilt as the squeezed-up phone version; on full-size screens it is rebuilt as the desktop version in the same style, with Shop as one row of buttons that open to their sub-pages. Both keep the About text word for word, use the header's own logo with the undated Feefo badge right beside it, drop the old card icons, and copy the main menu for Shop. A window that is resized after the page has loaded keeps the footer it was built with until the page is refreshed. */
(function () {
  var mq = window.matchMedia ? window.matchMedia('(max-width:767px)') : { matches: false };

  // ===== Social links. Facebook comes from the theme's existing footer link; the rest are set here. =====
  var INSTAGRAM_URL = 'https://www.instagram.com/discountcoffee/';
  var TIKTOK_URL = 'https://www.tiktok.com/@discountcoffee';
  var LINKEDIN_URL = 'https://www.linkedin.com/company/discountcoffee';

  // Feefo Platinum Trusted Service Award badge, white version with no year (2 Nov: supplied by Zac, embedded so no upload is needed)
  var FEEFO_NO_YEAR = 'https://cdn.shopify.com/s/files/1/0360/6353/files/feefo-platinum-no-year-white.png?v=1793652247';

  var TIKTOK_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/></svg>';

  function $(id) { return document.getElementById(id); }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function titleCase(s) { return String(s).toLowerCase().replace(/(^|[\s(\/-])([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); }); }
  function clean(s) { return String(s).replace(/\s+/g, ' ').trim(); }

  // Copyright: the year in the About text is replaced with this year, every time the page loads
  function yearFix() {
    var seo = $('footer-bottom-seo');
    if (!seo) return null;
    var yr = String(new Date().getFullYear());
    var cp = null;
    Array.prototype.forEach.call(seo.querySelectorAll('p'), function (p) {
      if (/©|copyright/i.test(p.textContent)) cp = p;
    });
    if (cp) {
      var t = cp.textContent;
      var n = t.replace(/(©\s*)\d{4}(?:\s*[-–]\s*\d{4})?/, '$1' + yr);
      if (n !== t) cp.textContent = n;
    }
    return cp;
  }

  // Help & information: [title, page]
  var HELP = [
    ['Help Centre', '/pages/customer-service'],
    ['Contact Us', '/pages/contact-us'],
    ['FAQs', '/pages/frequently-asked-questions'],
    ['Our Delivery', '/pages/our-delivery'],
    ['Damages & Returns', '/pages/damages-returns'],
    ['Feefo Reviews', '/pages/discount-coffee-reviews'],
    ['About Us', '/pages/about-us'],
    ['Business Enquiries', '/pages/business-page'],
    ['Latest News', '/blogs/news']
  ];

  // ---- shared helpers ----
  function makeSocial(contact) {
    var fb = contact.querySelector('#footer-social-facebook a');
    var socials = [
      ['Facebook', '<i class="fa fa-facebook" aria-hidden="true"></i>', fb ? fb.getAttribute('href') : ''],
      ['Instagram', '<i class="fa fa-instagram" aria-hidden="true"></i>', INSTAGRAM_URL],
      ['TikTok', TIKTOK_SVG, TIKTOK_URL],
      ['LinkedIn', '<i class="fa fa-linkedin" aria-hidden="true"></i>', LINKEDIN_URL]
    ].filter(function (s) { return s[2]; });
    if (!socials.length) return null;
    var ul = document.createElement('ul');
    ul.className = 'dc-fsocial';
    ul.innerHTML = socials.map(function (s) {
      return '<li><a href="' + esc(s[2]) + '" target="_blank" rel="noopener" aria-label="' + s[0] + '">' + s[1] + '</a></li>';
    }).join('');
    return ul;
  }

  // the Feefo badge with the year taken off, in its own wrapper (or null if there is none)
  function makeTrust(legal) {
    var feefo = null;
    Array.prototype.forEach.call(legal.children, function (c) { if (c.tagName === 'A') feefo = c; });
    if (!feefo) return null;
    var fimg = feefo.querySelector('img');
    if (fimg) {
      fimg.removeAttribute('srcset');
      fimg.removeAttribute('width');
      fimg.removeAttribute('height');
      fimg.setAttribute('src', FEEFO_NO_YEAR);
      fimg.setAttribute('alt', 'Feefo Platinum Trusted Service Award');
    }
    var trust = document.createElement('div');
    trust.className = 'dc-ftrust';
    trust.appendChild(feefo);
    return trust;
  }

  function contactHrefs() {
    var tel = $('footer-contact-tel'), mail = $('footer-contact-email');
    return {
      tel: tel && tel.getAttribute('href') ? tel.getAttribute('href').replace(/\s+/g, '') : 'tel:+443304411122',
      mail: mail && mail.getAttribute('href') ? mail.getAttribute('href') : 'mailto:sales@discountcoffee.co.uk'
    };
  }

  function hoursLine() {
    var hours = document.createElement('p');
    hours.className = 'dc-fhours';
    var hs = document.createElement('span');
    hs.textContent = 'Phones Monday to Friday, 9am to 5pm.';
    hours.appendChild(hs);
    if (window.dcPaintStatus) {
      window.dcPaintStatus(hs);
      hs.textContent = hs.textContent.replace(/\s*Live chat open 24 hours\.?/i, '').replace(/\s+$/, '');
    }
    return hours;
  }

  function headerLogoSrc(legal, preferDesktop) {
    var order = preferDesktop ? ['logo-desktop', 'logo-retina'] : ['logo-retina', 'logo-desktop'];
    var hl = null;
    order.forEach(function (id) {
      var el = $(id);
      if (el && !hl && el.offsetParent !== null) hl = el;
    });
    if (!hl) hl = $(order[0]) || $(order[1]) || legal.querySelector('#logo-footer');
    return hl ? (hl.getAttribute('src') || hl.currentSrc || '') : '';
  }

  // ---- Shop: a copy of the main menu, all the way down ----
  function linkOk(a) { return a && clean(a.textContent) && (a.getAttribute('href') || '') !== '#'; }

  // reads the main menu into a tree: option > sub-heading > page
  function menuTree() {
    var tree = [];
    var rows = document.querySelectorAll('#main-nav-pulldown-menus .main-nav-pulldown-menus-row > li');
    Array.prototype.forEach.call(rows, function (li) {
      if (/^(login|register|account|logout)-pulldown-menu$/.test(li.id)) return;
      var a = li.querySelector('a.mobile-nav-top-header');
      if (!a) return;
      var title = clean(a.textContent);
      if (!title) return;
      var node = { title: title, href: a.getAttribute('href') || '/', kids: [] };
      var sub = li.querySelector('.pulldown-menu-inner-subnav-row');
      if (sub) {
        var blocks = sub.querySelectorAll('.mobile-ul-list .pulldown-menu-nav-level-2');
        if (blocks.length) {
          Array.prototype.forEach.call(blocks, function (b) {
            var head = b.querySelector('dt a');
            if (!linkOk(head)) return;
            var kid = { title: clean(head.textContent), href: head.getAttribute('href'), kids: [] };
            Array.prototype.forEach.call(b.querySelectorAll('dd a'), function (x) {
              if (x.parentNode && x.parentNode.classList.contains('dc-viewall')) return;
              if (linkOk(x)) kid.kids.push({ title: clean(x.textContent), href: x.getAttribute('href'), kids: [] });
            });
            node.kids.push(kid);
          });
        } else {
          Array.prototype.forEach.call(sub.querySelectorAll('.pulldown-menu-nav-level-2 dd a'), function (x) {
            if (x.parentNode && x.parentNode.classList.contains('dc-viewall')) return;
            if (linkOk(x)) node.kids.push({ title: clean(x.textContent), href: x.getAttribute('href'), kids: [] });
          });
        }
      }
      tree.push(node);
    });
    return tree;
  }

  // ================= PHONE FOOTER =================
  function group(title, bodyEl) {
    var g = document.createElement('div');
    g.className = 'dc-fg';
    var h = document.createElement('button');
    h.type = 'button';
    h.className = 'dc-fhead';
    h.setAttribute('aria-expanded', 'false');
    h.textContent = title;
    bodyEl.classList.add('dc-fbody');
    g.appendChild(h);
    g.appendChild(bodyEl);
    h.addEventListener('click', function () {
      var open = g.classList.toggle('dc-fopen');
      h.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    return g;
  }

  function leafLink(n, plainTitle) {
    var a = document.createElement('a');
    a.href = n.href;
    a.textContent = plainTitle ? n.title : titleCase(n.title);
    return a;
  }

  // one closed row; tap to open. Its panel starts with 'View all' and then lists its pages, and any page that has pages of its own is another closed row.
  function rowEl(n, isTop) {
    var r = document.createElement('div');
    r.className = 'dc-sr';
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'dc-srh';
    b.setAttribute('aria-expanded', 'false');
    b.textContent = isTop ? n.title : titleCase(n.title);
    var panel = document.createElement('div');
    panel.className = 'dc-srb';
    var all = document.createElement('a');
    all.href = n.href;
    all.textContent = 'View all ' + titleCase(n.title);
    panel.appendChild(all);
    n.kids.forEach(function (k) {
      panel.appendChild(k.kids && k.kids.length ? rowEl(k, false) : leafLink(k, false));
    });
    b.addEventListener('click', function () {
      var open = r.classList.toggle('dc-sopen');
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    r.appendChild(b);
    r.appendChild(panel);
    return r;
  }

  function shopFromMenu(top) {
    var body = document.createElement('div');
    body.className = 'dc-fshop';
    var tree = menuTree();
    tree.forEach(function (n) {
      if (!n.kids.length) {
        var one = document.createElement('a');
        one.className = 'dc-srh' + (/^sale$/i.test(n.title) ? ' dc-srsale' : '');
        one.href = n.href;
        one.textContent = n.title;
        var w = document.createElement('div');
        w.className = 'dc-sr';
        w.appendChild(one);
        body.appendChild(w);
      } else {
        body.appendChild(rowEl(n, true));
      }
    });
    if (!tree.length) {
      // fallback: the theme's own footer lists, as plain links
      Array.prototype.slice.call(top.querySelectorAll('.footer-nav-item a')).forEach(function (l) {
        var x = document.createElement('div');
        x.className = 'dc-sr';
        var y = document.createElement('a');
        y.className = 'dc-srh';
        y.href = l.getAttribute('href') || '/';
        y.textContent = clean(l.textContent);
        x.appendChild(y);
        body.appendChild(x);
      });
    }
    return body;
  }

  function buildPhone(cp) {
    var f = $('footer'), inner = $('footer-inner');
    var top = $('footer-inner-top'), contact = $('footer-bottom-contact'), legal = $('footer-bottom-legal'), seo = $('footer-bottom-seo');
    if (!f || !inner || !top || !contact || !legal || !seo || f.classList.contains('dc-fdone')) return;

    var wrap = document.createElement('div');
    wrap.className = 'dc-fnew';

    // 1. the header's own logo with the Feefo badge right next to it (centred)
    var brand = document.createElement('div');
    brand.className = 'dc-fbrand';
    var src = headerLogoSrc(legal, false);
    if (src) {
      var la = document.createElement('a');
      la.className = 'dc-flogo';
      la.href = '/';
      la.setAttribute('aria-label', 'Discount Coffee home');
      la.innerHTML = '<img src="' + esc(src) + '" alt="Discount Coffee Wholesale Supplies" width="150">';
      brand.appendChild(la);
    }
    var trust = makeTrust(legal);
    if (trust) brand.appendChild(trust);
    if (brand.children.length) wrap.appendChild(brand);

    // 2. About text (moved up; its words are untouched except the year)
    var cpEl = cp;
    if (cpEl && cpEl.parentNode) cpEl.parentNode.removeChild(cpEl);
    var body = document.createElement('div');
    body.className = 'dc-seo-body';
    Array.prototype.slice.call(seo.childNodes).forEach(function (n) {
      if (n.nodeType === 1 && n.classList.contains('footer-title')) return;
      body.appendChild(n);
    });
    seo.appendChild(body);
    var more = document.createElement('button');
    more.type = 'button';
    more.className = 'dc-fmore';
    more.textContent = 'Read more';
    more.addEventListener('click', function () {
      var open = seo.classList.toggle('dc-fseo-open');
      more.textContent = open ? 'Show less' : 'Read more';
    });
    seo.appendChild(more);
    wrap.appendChild(seo);

    // 3. one row: Help Centre / Call / Email, with the social icons beside them
    var hrefs = contactHrefs();
    var row = document.createElement('div');
    row.className = 'dc-frow';
    var ct = document.createElement('div');
    ct.className = 'dc-fct';
    ct.innerHTML = '<a href="/pages/customer-service"><i class="fa fa-life-ring" aria-hidden="true"></i><span>Help</span></a>' +
      '<a href="' + esc(hrefs.tel) + '"><i class="fa fa-phone" aria-hidden="true"></i><span>Call</span></a>' +
      '<a href="' + esc(hrefs.mail) + '"><i class="fa fa-envelope-o" aria-hidden="true"></i><span>Email</span></a>';
    row.appendChild(ct);
    var socialUl = makeSocial(contact);
    if (socialUl) row.appendChild(socialUl);
    wrap.appendChild(row);
    wrap.appendChild(hoursLine());

    // 4. three rows that open (all closed to start with)
    var acc = document.createElement('div');
    acc.className = 'dc-facc';
    acc.appendChild(group('Shop', shopFromMenu(top)));
    var help = document.createElement('div');
    help.className = 'dc-fhelp';
    help.innerHTML = HELP.map(function (h) { return '<a href="' + h[1] + '">' + esc(h[0]) + '</a>'; }).join('');
    acc.appendChild(group('Help & information', help));
    var find = document.createElement('div');
    var addr = contact.querySelector('address');
    var ph = contact.querySelector('p');
    if (addr) find.appendChild(addr);
    if (ph) find.appendChild(ph);
    acc.appendChild(group('Find us', find));
    wrap.appendChild(acc);

    var plistP = legal.querySelector('#footer-payment-list'); if (plistP) wrap.appendChild(plistP);
    // 5. Klarna message
    var kl = legal.querySelector('klarna-placement');
    if (kl && kl.parentNode) { kl.parentNode.removeChild(kl); kl = null; }
    if (kl) {
      var pay = document.createElement('div');
      pay.className = 'dc-fpay';
      pay.appendChild(kl);
      wrap.appendChild(pay);
    }

    // 6. copyright (current year) and legal links, centred
    var copy = document.createElement('div');
    copy.className = 'dc-fcopy';
    if (!cpEl) {
      cpEl = document.createElement('p');
      cpEl.textContent = 'Copyright © ' + new Date().getFullYear() + ' DiscountCoffee';
    }
    copy.appendChild(cpEl);
    var legalNav = null;
    Array.prototype.forEach.call(legal.children, function (c) { if (c.tagName === 'NAV') legalNav = c; });
    if (legalNav) copy.appendChild(legalNav);
    wrap.appendChild(copy);

    inner.insertBefore(wrap, inner.firstChild);
    f.classList.add('dc-fdone');
  }

  // ================= DESKTOP FOOTER =================
  // Shop on desktop: one row of buttons (Coffee, Syrup, ...). Tapping one opens a panel underneath with its sub-pages in columns; tapping again closes it. One panel open at a time, none to start with.
  function desktopShop(tree, top) {
    var shop = document.createElement('div');
    shop.className = 'dc-fd-shop';
    var tabs = document.createElement('div');
    tabs.className = 'dc-fd-tabs';
    var panels = document.createElement('div');
    panels.className = 'dc-fd-panels';
    var pairs = [];

    tree.forEach(function (n) {
      if (!n.kids.length) {
        var one = document.createElement('a');
        one.className = 'dc-fd-tab' + (/^sale$/i.test(n.title) ? ' dc-fd-sale' : '');
        one.href = n.href;
        one.textContent = n.title;
        tabs.appendChild(one);
        return;
      }
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'dc-fd-tab';
      b.setAttribute('aria-expanded', 'false');
      b.textContent = n.title;
      tabs.appendChild(b);

      var p = document.createElement('div');
      p.className = 'dc-fd-panel';
      var all = document.createElement('a');
      all.className = 'dc-fd-all';
      all.href = n.href;
      all.textContent = 'View all ' + titleCase(n.title);
      p.appendChild(all);

      var grid = document.createElement('div');
      grid.className = 'dc-fd-pgrid';
      var leaves = [];
      n.kids.forEach(function (k) {
        if (k.kids && k.kids.length) {
          var col = document.createElement('div');
          col.className = 'dc-fd-pc';
          var h = document.createElement('a');
          h.className = 'dc-fd-ph';
          h.href = k.href;
          h.textContent = titleCase(k.title);
          col.appendChild(h);
          var ul = document.createElement('ul');
          k.kids.forEach(function (x) {
            var li = document.createElement('li');
            li.appendChild(leafLink(x, false));
            ul.appendChild(li);
          });
          col.appendChild(ul);
          grid.appendChild(col);
        } else {
          leaves.push(k);
        }
      });
      if (leaves.length) {
        if (grid.children.length) {
          var lc = document.createElement('div');
          lc.className = 'dc-fd-pc';
          var lul = document.createElement('ul');
          leaves.forEach(function (x) {
            var li = document.createElement('li');
            li.appendChild(leafLink(x, false));
            lul.appendChild(li);
          });
          lc.appendChild(lul);
          grid.appendChild(lc);
        } else {
          // a plain list of pages (Cups, Brands): laid out in columns
          var flat = document.createElement('ul');
          flat.className = 'dc-fd-flat';
          leaves.forEach(function (x) {
            var li = document.createElement('li');
            li.appendChild(leafLink(x, false));
            flat.appendChild(li);
          });
          p.appendChild(flat);
        }
      }
      if (grid.children.length) p.appendChild(grid);
      panels.appendChild(p);
      pairs.push({ b: b, p: p });

      b.addEventListener('click', function () {
        var wasOpen = p.classList.contains('dc-fd-open');
        pairs.forEach(function (x) {
          x.p.classList.remove('dc-fd-open');
          x.b.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          p.classList.add('dc-fd-open');
          b.setAttribute('aria-expanded', 'true');
        }
      });
    });

    shop.appendChild(tabs);
    shop.appendChild(panels);
    if (!tree.length) {
      // fallback: the theme's own footer lists
      Array.prototype.slice.call(top.querySelectorAll('.footer-nav')).forEach(function (n) { shop.appendChild(n); });
    }
    return shop;
  }

  function buildDesktop(cp) {
    var f = $('footer'), inner = $('footer-inner');
    var top = $('footer-inner-top'), contact = $('footer-bottom-contact'), legal = $('footer-bottom-legal'), seo = $('footer-bottom-seo');
    if (!f || !inner || !top || !contact || !legal || !seo || f.classList.contains('dc-fdone')) return;

    var wrap = document.createElement('div');
    wrap.className = 'dc-fnew dc-fdesk';

    // 1. top strip: the header's own logo with the Feefo badge right next to it on the left; Help Centre / Call / Email and the social icons on the right
    var strip = document.createElement('div');
    strip.className = 'dc-fd-top';
    var brand = document.createElement('div');
    brand.className = 'dc-fd-brand';
    var src = headerLogoSrc(legal, true);
    if (src) {
      var la = document.createElement('a');
      la.className = 'dc-flogo';
      la.href = '/';
      la.setAttribute('aria-label', 'Discount Coffee home');
      la.innerHTML = '<img src="' + esc(src) + '" alt="Discount Coffee Wholesale Supplies" width="230">';
      brand.appendChild(la);
    }
    var trust = makeTrust(legal);
    if (trust) brand.appendChild(trust);
    strip.appendChild(brand);

    var hrefs = contactHrefs();
    var act = document.createElement('div');
    act.className = 'dc-fd-act';
    var btns = document.createElement('div');
    btns.className = 'dc-fd-btns';
    btns.innerHTML = '<a href="/pages/customer-service"><i class="fa fa-life-ring" aria-hidden="true"></i><span>Help</span></a>' +
      '<a href="' + esc(hrefs.tel) + '"><i class="fa fa-phone" aria-hidden="true"></i><span>Call</span></a>' +
      '<a href="' + esc(hrefs.mail) + '"><i class="fa fa-envelope-o" aria-hidden="true"></i><span>Email</span></a>';
    act.appendChild(btns);
    var socialUl = makeSocial(contact);
    if (socialUl) act.appendChild(socialUl);
    strip.appendChild(act);
    wrap.appendChild(strip);

    // 2. Shop: one row of buttons that open to their sub-pages
    wrap.appendChild(desktopShop(menuTree(), top));

    // 3. three columns: About, Help & information, Find us
    var bottom = document.createElement('div');
    bottom.className = 'dc-fd-bottom';
    var cpEl = cp;
    if (cpEl && cpEl.parentNode) cpEl.parentNode.removeChild(cpEl);
    var aboutCol = document.createElement('div');
    aboutCol.appendChild(seo);
    bottom.appendChild(aboutCol);

    var helpCol = document.createElement('div');
    helpCol.innerHTML = '<h4 class="dc-fd-label">Help &amp; information</h4><ul class="dc-fd-help">' +
      HELP.map(function (h) { return '<li><a href="' + h[1] + '">' + esc(h[0]) + '</a></li>'; }).join('') + '</ul>';
    bottom.appendChild(helpCol);

    var findCol = document.createElement('div');
    findCol.className = 'dc-fd-find';
    var fl = document.createElement('h4');
    fl.className = 'dc-fd-label';
    fl.textContent = 'Find us';
    findCol.appendChild(fl);
    var addr = contact.querySelector('address');
    var ph = contact.querySelector('p');
    if (addr) findCol.appendChild(addr);
    if (ph) findCol.appendChild(ph);
    findCol.appendChild(hoursLine());
    bottom.appendChild(findCol);
    wrap.appendChild(bottom);

    var plistD = legal.querySelector('#footer-payment-list'); if (plistD) wrap.appendChild(plistD);
    // 4. Klarna message, copyright (current year) and legal links, centred
    var copy = document.createElement('div');
    copy.className = 'dc-fd-copy';
    var kl = legal.querySelector('klarna-placement');
    if (kl && kl.parentNode) { kl.parentNode.removeChild(kl); kl = null; }
    if (kl) copy.appendChild(kl);
    if (!cpEl) {
      cpEl = document.createElement('p');
      cpEl.textContent = 'Copyright © ' + new Date().getFullYear() + ' DiscountCoffee';
    }
    copy.appendChild(cpEl);
    var legalNav = null;
    Array.prototype.forEach.call(legal.children, function (c) { if (c.tagName === 'NAV') legalNav = c; });
    if (legalNav) copy.appendChild(legalNav);
    wrap.appendChild(copy);

    inner.insertBefore(wrap, inner.firstChild);
    f.classList.add('dc-fdone');
  }

  function init() {
    var cp = yearFix();
    if (mq.matches) buildPhone(cp); else buildDesktop(cp);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* NEW badge: a menu link written "NEW - Something" (or "New Something") shows a blue NEW badge, then the name. Works for the header menus and the footer Shop list. */
(function () {
  var SEL = '.pulldown-menu-inner a, .dc-dm a, .dc-fshop a, .dc-fd-shop a, .mobile-ul-list a';
  function badge(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll(SEL), function (a) {
      if (a.getAttribute('data-newb') || a.children.length) return;
      var t = a.textContent;
      var m = /^\s*new\b\s*[-–—:]?\s*(\S.*)$/i.exec(t);
      if (!m) return;
      a.setAttribute('data-newb', '1');
      a.textContent = '';
      var b = document.createElement('span');
      b.className = 'dc-newb';
      b.textContent = 'NEW';
      a.appendChild(b);
      a.appendChild(document.createTextNode(' ' + m[1].trim()));
    });
  }
  var timer = null;
  function later() { clearTimeout(timer); timer = setTimeout(function () { badge(); }, 150); }
  function start() {
    badge();
    if (window.MutationObserver) new MutationObserver(later).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* TRENDING badge: a menu link written "Cherry Blossom < TRENDING" shows the name, then an orange TRENDING pill. */
(function () {
  var SEL = '.pulldown-menu-inner a, .dc-dm a, .dc-fshop a, .dc-fd-shop a, .mobile-ul-list a';
  function badge() {
    Array.prototype.forEach.call(document.querySelectorAll(SEL), function (a) {
      if (a.getAttribute('data-trb') || a.children.length) return;
      var m = /^\s*(\S.*?)\s*(?:<|&lt;)\s*trending\s*$/i.exec(a.textContent);
      if (!m) return;
      a.setAttribute('data-trb', '1');
      a.textContent = m[1] + ' ';
      var b = document.createElement('span');
      b.className = 'dc-trb';
      b.textContent = 'TRENDING';
      a.appendChild(b);
    });
  }
  var timer = null;
  function later() { clearTimeout(timer); timer = setTimeout(badge, 150); }
  function start() {
    badge();
    if (window.MutationObserver) new MutationObserver(later).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
